import { updatePinCode } from "../../utils/apiClient";

/**
 * Change the user's password.
 *
 * @param {string} oldPin - Current plain-text password.
 * @param {string} newPin - New plain-text password.
 * @param {string} newConfirmation - Confirmation of the new password.
 */
export const changePinCode = async (oldPin, newPin, newConfirmation, options = {}) => {
  const response = await updatePinCode(oldPin, newPin, newConfirmation, options);

  if (response && response.decryptedData) {
    return response.decryptedData;
  }

  if (response && response.data) {
    return response.data;
  }

  return response;
};

export default { changePinCode };
